module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ThinItalic.217b76e.eot";